import angular from "angular";

import './popover.component.scss';

export default ($timeout) => {
  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    transclude: {
      element: "?vuiPopoverElement",
      content: "?vuiPopoverContent"
    },
    scope: {
      calculatePosition: "<?vuiCalculatePosition",
      openEvent: "<?vuiOpenEvent",
      actions: "<?vuiActions"
    },
    template: require('./popover.component.html'),
    link: (scope, element) => {

      scope.openEvent = scope.openEvent || 'click';
      scope.openned = false;

      const findElemByClass = (className) => {
        const list = element.find('div')
        for (let i = 0; i < list.length; i++) {
          if (list[i].className.indexOf(className) >= 0) {
            return angular.element(list[i]);
          }
        }
      }

      const findElemsByClass = (className) => {
        const list = element.find('div')
        const result = [];
        for (let i = 0; i < list.length; i++) {
          if (list[i].className.indexOf(className) >= 0) {
            result.push(angular.element(list[i]));
          }
        }

        return result;
      }

      const calculatePosition = (isBottom, dropdown) => {
        if (scope.calculatePosition) {
          return scope.calculatePosition(isBottom, dropdown)
        }

        const scrollTop = document.getElementsByClassName('vui-content')[0].scrollTop
        return (isBottom ? -(dropdown.offsetHeight + 40) : 16) - scrollTop;
      }

      const dropdown = findElemByClass('vui-popover__dropdown');

      scope.onClickOpen = () => {
        if (scope.openEvent === 'click') {
          scope.open();
        }
      }

      scope.onClickClose = () => {
        if (scope.openEvent === 'click') {
          scope.close();
        }
      }

      scope.open = () => {
        scope.openned = true;
        element.addClass('vui-popover-container--opening');
        element.addClass('vui-popover-container--opened');
        $timeout(() => {
          element.removeClass('vui-popover-container--opening');
        });
        const rect = element[0].getClientRects()[0];

        const marginTop = calculatePosition(rect.bottom + dropdown[0].offsetHeight > window.innerHeight, dropdown[0])
        dropdown.css('margin-top', marginTop + 'px');

        const activeItems = findElemsByClass('active');
        for (const item of activeItems) {
          item[0].scrollIntoView({block: "nearest", inline: "nearest"});
        }
      }

      scope.close = () => {
        scope.openned = false;
        element.addClass('vui-popover-container--opening');
        $timeout(() => {
          element.removeClass('vui-popover-container--opening')
          element.removeClass('vui-popover-container--opened')
        }, 250);
        element.focus ? element.focus() : element[0].focus();
      }

      if (scope.openEvent !== 'click') {
        element[0].addEventListener("mouseover", (e) => {
          if (!scope.openned) {
            scope.open();
          }
        });
        element[0].addEventListener("mouseleave", (e) => {
          if (scope.openned) {
            scope.close();
          }
        });
      }

      if (!scope.actions) {
        scope.actions = {};
      }
      scope.actions.open = scope.open;
      scope.actions.close = scope.close;

    }
  };
}
